const name = 'password'
const validator = (value, min) => new RegExp('^(?=.*[A-Za-z])(?=.*\\d).{' + min + ',}$').test(value)
// const validator = (value, min) => new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{' + min + ',})').test(value)

export default {
  name,
  validator
}
